import React from "react";

import HomeHeroes from "./HomeHeroes";

import { useLatestAnnouncements } from "../../announcements/hooks/useLatestAnnouncements";
import { useLatestFacebookPosts } from "../../social/hooks/useLatestFacebookPosts";

const HomeHeroesContainer = () => {
  const {
    announcements = [],
    isLoading: isAnnouncementsLoading,
    error: announcementsError
  } = useLatestAnnouncements({
    limit: 3
  });

  const {
    posts: socialPosts,
    isLoading: isSocialLoading,
    error: socialError
  } = useLatestFacebookPosts();

  return (
    <HomeHeroes
      announcements={announcements}
      isAnnouncementsLoading={isAnnouncementsLoading}
      announcementsError={announcementsError}
      socialPosts={socialPosts}
      isSocialLoading={isSocialLoading}
      socialError={socialError}
    />
  );
};

export default HomeHeroesContainer;